<template>
<div style="max-width: 220px;">
  <v-btn block v-if="can(meta.permission)" small @click="setUserName(data)" class="btn-list"> {{data.users.username}} - {{data.users.name +' ' + data.users.lastName}}</v-btn>
  <v-chip
      v-else
      small
      class="text-center"
      color="red"
      label
      outlined
  >
    {{data.users.username}} - {{data.users.name +' ' + data.users.lastName}}
  </v-chip>
</div>
</template>

<script>
export default {
  name: "UsernameBtn",
  props: {
    data:{},
    setUserName:{
      type: Function
    },
    meta: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>